import api from "./axios";
import type { User, CamperTeam } from "../types";

export interface UserCabinAssignment {
  id: number;
  cabinId: number;
  userId: number;
  termId: number | null;
  overrideCabinId: number | null;
  cabin?: { id: number; name: string } | null;
  overrideCabin?: { id: number; name: string } | null;
}

export const adminApi = {
  listUsers: async (): Promise<User[]> => {
    const res = await api.get<User[]>("/admin/users");
    return res.data;
  },

  setUserTeam: async (id: number, team: CamperTeam | null): Promise<User> => {
    const res = await api.patch<User>(`/admin/users/${id}/team`, { team });
    return res.data;
  },

  userCabinAssignments: async (userId: number, termId?: number): Promise<UserCabinAssignment[]> => {
    const res = await api.get<UserCabinAssignment[]>(`/admin/users/${userId}/cabin-assignments`, {
      params: termId !== undefined ? { termId } : undefined,
    });
    return res.data;
  },

  testEmail: async (to: string): Promise<{ ok: boolean; smtp: boolean }> => {
    const res = await api.post<{ ok: boolean; smtp: boolean }>("/admin/test-email", { to });
    return res.data;
  },
};
